const checkForPreRequisitesCompletion = (offersData) => {
  if (!offersData || !offersData.contentSettingsData) {
    return true;
  }

  let preReqDone = true;
  const contentIds = offersData.contentSettingsData.map(content => content.contentId);

  contentIds.forEach((contentId) => {
    const contentState = offersData.statesData.filter(
      state => state && state.contentId === contentId
    )[0];
    if (!contentState || contentState.completionStatus !== 'complete') {
      preReqDone = false;
    }
  });

  return preReqDone;
};

export default checkForPreRequisitesCompletion;
